import BuildItemSkeleton from '@/components/BuildListItem/BuildItemSkeleton';

type BuildListSkeletonContentProps = {
  count: number;
  active?: boolean;
  canRunBuild?: boolean;
  showAppInfo?: boolean;
};
const BuildListSkeletonContent = ({
  count,
  active = true,
  canRunBuild = false,
  showAppInfo = true,
}: BuildListSkeletonContentProps): JSX.Element => (
  <>
    {Array(count)
      .fill(0)
      .map((_, idx) => idx)
      .map((val) => (
        <BuildItemSkeleton key={val} active={active} canRunBuild={canRunBuild} showAppInfo={showAppInfo} />
      ))}
  </>
);

export { BuildListSkeletonContentProps };
export default BuildListSkeletonContent;
